import { cachePublicSearch } from "#shared/lib/cache-public-search";
import { usePublicDataRequest } from "./public-data-request";
import { Meilisearch } from "meilisearch";

export const useSearchClient = (): Meilisearch => {
  const nuxtApp = useNuxtApp();

  const { searchUrl, searchApiKey } = useRuntimeConfig()?.public;

  if (!nuxtApp._searchClient) {
    const searchClient = new Meilisearch({
      host: searchUrl as string,
      apiKey: searchApiKey as string,
    });
    if (import.meta.server) {
      cachePublicSearch(searchClient, usePublicDataRequest());
    }
    nuxtApp._searchClient = searchClient;
  }

  return nuxtApp._searchClient as Meilisearch;
};
